<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
    mounted(){
      document.title = this.$t('app_title')
    }
  }
  
</script>